module.exports = __webpack_public_path__ + "img/gb93-87-12.prt.80eeefff.jpg";